import WindowApp from 'utilities/WindowApp';
import AsyncLoad from '~utilities/async-load';
import DetectTouch from '~utilities/detect-touch';

class AsyncLoadExtend extends AsyncLoad {
    constructor(element = false) {
        super(element);
    }

    inAnimation() {
      super.inAnimation();

      const HAS_TOUCH = 'has--touch';
      const HAS_MOUSE = `has--mouse`;

      document.documentElement.classList.add(DetectTouch.hasTouch ? HAS_TOUCH : HAS_MOUSE ) 
      if(window.location.pathname != '/') document.documentElement.classList.remove('nav--light');
    }

    outAnimation() {
      super.outAnimation();

      window.app = new WindowApp();
    }
}
export default AsyncLoadExtend;